import { Component, Input, OnInit, inject } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import {Utilisateur} from '../../../interface/api/Utilisateur';
import {Subscription} from 'rxjs';
import {HydraCollection} from '../../../class/generic/hydra-collection';
import {api} from '../../../api/api-dictionnary';
import {HydraService} from '../../../core/services/hydra.service';
import {ToolsService} from '../../services/tools/tools.service';
import { MatDialogRef, MatDialogTitle, MatDialogContent, MatDialogActions, MatDialogClose } from '@angular/material/dialog';
import {TranslateService} from '@ngx-translate/core';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { ControlsMessagesComponent } from '../controls-messages/controls-messages.component';

import { MatSelect } from '@angular/material/select';
import { MatOption } from '@angular/material/core';
import { MatCheckbox } from '@angular/material/checkbox';
import { MatButton } from '@angular/material/button';

@Component({
    selector: 'app-modal-add-user',
    templateUrl: './modal-add-user.component.html',
    styleUrls: ['./modal-add-user.component.scss'],
    imports: [MatDialogTitle, CdkScrollable, MatDialogContent, FormsModule, ReactiveFormsModule, ControlsMessagesComponent, MatSelect, MatOption, MatCheckbox, MatDialogActions, MatButton, MatDialogClose]
})
export class ModalAddUserComponent implements OnInit {
    translate = inject(TranslateService);
    private _formBuilder = inject(UntypedFormBuilder);
    private hydraService = inject(HydraService);
    private toolService = inject(ToolsService);
    dialogRef = inject<MatDialogRef<ModalAddUserComponent>>(MatDialogRef);

    firstFormGroup: UntypedFormGroup = new UntypedFormGroup({});
    selected = 'fr';
    private subscriptions: Subscription[] = [];
    public roles = []; // 0 => { checked, label}
    public displayInscriptionSuccessfull = false;

    profil: Utilisateur = null;
    @Input('profil') set field(profil: Utilisateur) {
        this.profil = profil;
    }

    constructor() {}

    public compareByid(itemOne, itemTwo) {
        return itemOne && itemTwo && itemOne.id == itemTwo.id;
    }

    getRoles() {
        this.subscriptions.push(
            this.hydraService
                .getList(api.roleUtilisateur, true)
                .subscribe((res: HydraCollection) => {
                    res.getMember().map((item, index) => {
                        const addRole = {
                            id: item['@id'],
                            label: item.label,
                            checked: item.label == 'Candidat',
                        };
                        this.roles.push(addRole);
                    });
                })
        );
    }

    public addUser() {
        const data = { ...this.firstFormGroup.getRawValue() };
        //Set role
        data['utilisateurRoles'] = [];
        this.roles.map(role => {
            if (role.checked) {
                data['utilisateurRoles'].push(role['id']);
            }
        });

        let url = api.utilisateur;
        if (this.profil != null) {
            data['id'] = this.profil.id;
            url = api.utilisateur + '/' + this.profil.id;
        }

        this.hydraService.save(url, data).subscribe(
            res => {
                this.toolService.notificationSuccess(
                    'L\'utilisateur a bien été ajoutée'
                );
                if (this.profil == null) {
                    this.displayInscriptionSuccessfull = true;
                }
                this.dialogRef.close();
            },
            err => {
                this.dialogRef.close();
            }
        );
    }

    ngOnInit() {
        this.firstFormGroup = this._formBuilder.group({
            email: [
                this.profil != null ? this.profil.email : '',
                [Validators.required, Validators.email],
            ],
            nom: [
                this.profil != null ? this.profil.nom : '',
                Validators.required,
            ],
            prenom: [
                this.profil != null ? this.profil.prenom : '',
                Validators.required,
            ],
            locale: [
                this.profil != null ? this.profil.locale : 'fr',
                Validators.required,
            ],
        });
        this.getRoles();
    }

    get email() {
        return this.firstFormGroup.get('email');
    }
    get nom() {
        return this.firstFormGroup.get('nom');
    }
    get prenom() {
        return this.firstFormGroup.get('prenom');
    }
    get locale() {
        return this.firstFormGroup.get('locale');
    }
}
